import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PublishToggle from './component';
import editBlogPost from '../../../../modules/blog/editBlogPost';

function BlogPublishContainer({ isPublished, editBlogPost, match }) {
  const { id } = match.params;
  return (
    <PublishToggle isPublished={isPublished} setPublishStatus={() => editBlogPost(id, { isPublished: !isPublished, published: window.firebase.firestore.FieldValue.serverTimestamp() })} />
  )
}

function mapStateToProps(state) {
  return {
    isPublished: state.blogPosts.currentPost.isPublished,
  }
}

const mapActionToProps = {
  editBlogPost,
};

// TODO: ADD setPublishStatus for toggling the isPublished state and set timestamp

export default withRouter(connect(mapStateToProps, mapActionToProps)(BlogPublishContainer));


// WEBPACK FOOTER //
// ./src/pages/Admin/BlogDocument/BlogPublish/container.js